import { useUuid } from "./useUuid";

export interface GtmEvent {
  event?: string;
  loading_time?: string;
  memo?: string;
}

interface ApiInfo extends GtmEvent {
  UUID: string;
  date: string;
}

const useGtmSender = (props: any) => {
  const UUID = useUuid();

  const handleGtmClick = (event: GtmEvent) => {
    if (window.dataLayer) {
      const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, "0");
        const day = now.getDate().toString().padStart(2, "0");
        const hours = now.getHours().toString().padStart(2, "0");
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const seconds = now.getSeconds().toString().padStart(2, "0");
        const milliseconds = now.getMilliseconds().toString().padStart(3, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
      };
      const apiInfo: ApiInfo = {
        event: event.event || "",
        loading_time: event.loading_time || "",
        UUID,
        date: getCurrentDate(),
        memo: event.memo || "",
      };

      // console.log("GTM_SENDER:");
      // console.log(apiInfo);

      window.dataLayer.push(apiInfo);
    }
  };

  return handleGtmClick;
};

export default useGtmSender;
